<template>
  <div class="payment-unavailable">
    <!-- Simple Icon -->
    <div class="icon">❌</div>
    
    <!-- Message -->
    <h1 class="message">{{ text }}</h1>
  </div>
</template>

<script>
export default {
  name: 'PaymentUnavailable',
  props: ['text']
}
</script>

<style scoped>
.payment-unavailable {
  text-align: center;
  padding: 90px 20px;
}

.icon {
  font-size: 48px;
  margin-bottom: 20px;
  line-height: 1;
}

.message {
  font-size: 24px;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.4;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .payment-unavailable {
    padding: 40px 20px;
  }

  .icon {
    font-size: 40px;
    margin-bottom: 16px;
  }

  .message {
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .payment-unavailable {
    padding: 30px 15px;
  }

  .icon {
    font-size: 32px;
    margin-bottom: 12px;
  }

  .message {
    font-size: 18px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/payments/noAvailablePayment.vue